export const countries = [
  { name: 'United Kingdom', demonym: 'British', cca2: 'GB', cca3: 'GBR' },
  { name: 'Ireland', demonym: 'Irish', cca2: 'IE', cca3: 'IRL' },
  { name: 'Afghanistan', demonym: 'Afghan', cca2: 'AF', cca3: 'AFG' },
  { name: 'Åland Islands', demonym: 'Ålandish', cca2: 'AX', cca3: 'ALA' },
  { name: 'Albania', demonym: 'Albanian', cca2: 'AL', cca3: 'ALB' },
  { name: 'Algeria', demonym: 'Algerian', cca2: 'DZ', cca3: 'DZA' },
  { name: 'American Samoa', demonym: 'American Samoan', cca2: 'AS', cca3: 'ASM' },
  { name: 'Andorra', demonym: 'Andorran', cca2: 'AD', cca3: 'AND' },
  { name: 'Angola', demonym: 'Angolan', cca2: 'AO', cca3: 'AGO' },
  { name: 'Anguilla', demonym: 'Anguillian', cca2: 'AI', cca3: 'AIA' },
  { name: 'Antarctica', demonym: 'Antarctican', cca2: 'AQ', cca3: 'ATA' },
  { name: 'Antigua and Barbuda', demonym: 'Antiguan, Barbudan', cca2: 'AG', cca3: 'ATG' },
  { name: 'Argentina', demonym: 'Argentine', cca2: 'AR', cca3: 'ARG' },
  { name: 'Armenia', demonym: 'Armenian', cca2: 'AM', cca3: 'ARM' },
  { name: 'Aruba', demonym: 'Aruban', cca2: 'AW', cca3: 'ABW' },
  { name: 'Australia', demonym: 'Australian', cca2: 'AU', cca3: 'AUS' },
  { name: 'Austria', demonym: 'Austrian', cca2: 'AT', cca3: 'AUT' },
  { name: 'Azerbaijan', demonym: 'Azerbaijani', cca2: 'AZ', cca3: 'AZE' },
  { name: 'Bahamas', demonym: 'Bahamian', cca2: 'BS', cca3: 'BHS' },
  { name: 'Bahrain', demonym: 'Bahraini', cca2: 'BH', cca3: 'BHR' },
  { name: 'Bangladesh', demonym: 'Bangladeshi', cca2: 'BD', cca3: 'BGD' },
  { name: 'Barbados', demonym: 'Barbadian', cca2: 'BB', cca3: 'BRB' },
  { name: 'Belarus', demonym: 'Belarusian', cca2: 'BY', cca3: 'BLR' },
  { name: 'Belgium', demonym: 'Belgian', cca2: 'BE', cca3: 'BEL' },
  { name: 'Belize', demonym: 'Belizean', cca2: 'BZ', cca3: 'BLZ' },
  { name: 'Benin', demonym: 'Beninese', cca2: 'BJ', cca3: 'BEN' },
  { name: 'Bermuda', demonym: 'Bermudian', cca2: 'BM', cca3: 'BMU' },
  { name: 'Bhutan', demonym: 'Bhutanese', cca2: 'BT', cca3: 'BTN' },
  { name: 'Bolivia', demonym: 'Bolivian', cca2: 'BO', cca3: 'BOL' },
  { name: 'Bosnia and Herzegovina', demonym: 'Bosnian, Herzegovinian', cca2: 'BA', cca3: 'BIH' },
  { name: 'Botswana', demonym: 'Motswana', cca2: 'BW', cca3: 'BWA' },
  { name: 'Bouvet Island', demonym: '', cca2: 'BV', cca3: 'BVT' },
  { name: 'Brazil', demonym: 'Brazilian', cca2: 'BR', cca3: 'BRA' },
  { name: 'British Indian Ocean Territory', demonym: 'Indian', cca2: 'IO', cca3: 'IOT' },
  { name: 'British Virgin Islands', demonym: 'Virgin Islander', cca2: 'VG', cca3: 'VGB' },
  { name: 'Brunei', demonym: 'Bruneian', cca2: 'BN', cca3: 'BRN' },
  { name: 'Bulgaria', demonym: 'Bulgarian', cca2: 'BG', cca3: 'BGR' },
  { name: 'Burkina Faso', demonym: 'Burkinabe', cca2: 'BF', cca3: 'BFA' },
  { name: 'Burundi', demonym: 'Burundian', cca2: 'BI', cca3: 'BDI' },
  { name: 'Cambodia', demonym: 'Cambodian', cca2: 'KH', cca3: 'KHM' },
  { name: 'Cameroon', demonym: 'Cameroonian', cca2: 'CM', cca3: 'CMR' },
  { name: 'Canada', demonym: 'Canadian', cca2: 'CA', cca3: 'CAN' },
  { name: 'Cape Verde', demonym: 'Cape Verdian', cca2: 'CV', cca3: 'CPV' },
  { name: 'Caribbean Netherlands', demonym: 'Dutch', cca2: 'BQ', cca3: 'BES' },
  { name: 'Cayman Islands', demonym: 'Caymanian', cca2: 'KY', cca3: 'CYM' },
  { name: 'Central African Republic', demonym: 'Central African', cca2: 'CF', cca3: 'CAF' },
  { name: 'Chad', demonym: 'Chadian', cca2: 'TD', cca3: 'TCD' },
  { name: 'Chile', demonym: 'Chilean', cca2: 'CL', cca3: 'CHL' },
  { name: 'China', demonym: 'Chinese', cca2: 'CN', cca3: 'CHN' },
  { name: 'Christmas Island', demonym: 'Christmas Islander', cca2: 'CX', cca3: 'CXR' },
  { name: 'Cocos (Keeling) Islands', demonym: 'Cocos Islander', cca2: 'CC', cca3: 'CCK' },
  { name: 'Colombia', demonym: 'Colombian', cca2: 'CO', cca3: 'COL' },
  { name: 'Comoros', demonym: 'Comoran', cca2: 'KM', cca3: 'COM' },
  { name: 'Cook Islands', demonym: 'Cook Islander', cca2: 'CK', cca3: 'COK' },
  { name: 'Costa Rica', demonym: 'Costa Rican', cca2: 'CR', cca3: 'CRI' },
  { name: 'Croatia', demonym: 'Croatian', cca2: 'HR', cca3: 'HRV' },
  { name: 'Cuba', demonym: 'Cuban', cca2: 'CU', cca3: 'CUB' },
  { name: 'Curaçao', demonym: 'Dutch', cca2: 'CW', cca3: 'CUW' },
  { name: 'Cyprus', demonym: 'Cypriot', cca2: 'CY', cca3: 'CYP' },
  { name: 'Czechia', demonym: 'Czech', cca2: 'CZ', cca3: 'CZE' },
  { name: 'Denmark', demonym: 'Danish', cca2: 'DK', cca3: 'DNK' },
  { name: 'Djibouti', demonym: 'Djibouti', cca2: 'DJ', cca3: 'DJI' },
  { name: 'Dominica', demonym: 'Dominican', cca2: 'DM', cca3: 'DMA' },
  { name: 'Dominican Republic', demonym: 'Dominican', cca2: 'DO', cca3: 'DOM' },
  { name: 'DR Congo', demonym: 'Congolese', cca2: 'CD', cca3: 'COD' },
  { name: 'Ecuador', demonym: 'Ecuadorean', cca2: 'EC', cca3: 'ECU' },
  { name: 'Egypt', demonym: 'Egyptian', cca2: 'EG', cca3: 'EGY' },
  { name: 'El Salvador', demonym: 'Salvadoran', cca2: 'SV', cca3: 'SLV' },
  { name: 'Equatorial Guinea', demonym: 'Equatorial Guinean', cca2: 'GQ', cca3: 'GNQ' },
  { name: 'Eritrea', demonym: 'Eritrean', cca2: 'ER', cca3: 'ERI' },
  { name: 'Estonia', demonym: 'Estonian', cca2: 'EE', cca3: 'EST' },
  { name: 'Eswatini', demonym: 'Swazi', cca2: 'SZ', cca3: 'SWZ' },
  { name: 'Ethiopia', demonym: 'Ethiopian', cca2: 'ET', cca3: 'ETH' },
  { name: 'Falkland Islands', demonym: 'Falkland Islander', cca2: 'FK', cca3: 'FLK' },
  { name: 'Faroe Islands', demonym: 'Faroese', cca2: 'FO', cca3: 'FRO' },
  { name: 'Fiji', demonym: 'Fijian', cca2: 'FJ', cca3: 'FJI' },
  { name: 'Finland', demonym: 'Finnish', cca2: 'FI', cca3: 'FIN' },
  { name: 'France', demonym: 'French', cca2: 'FR', cca3: 'FRA' },
  { name: 'French Guiana', demonym: 'Guianan', cca2: 'GF', cca3: 'GUF' },
  { name: 'French Polynesia', demonym: 'French Polynesian', cca2: 'PF', cca3: 'PYF' },
  { name: 'French Southern and Antarctic Lands', demonym: 'French', cca2: 'TF', cca3: 'ATF' },
  { name: 'Gabon', demonym: 'Gabonese', cca2: 'GA', cca3: 'GAB' },
  { name: 'Gambia', demonym: 'Gambian', cca2: 'GM', cca3: 'GMB' },
  { name: 'Georgia', demonym: 'Georgian', cca2: 'GE', cca3: 'GEO' },
  { name: 'Germany', demonym: 'German', cca2: 'DE', cca3: 'DEU' },
  { name: 'Ghana', demonym: 'Ghanaian', cca2: 'GH', cca3: 'GHA' },
  { name: 'Gibraltar', demonym: 'Gibraltar', cca2: 'GI', cca3: 'GIB' },
  { name: 'Greece', demonym: 'Greek', cca2: 'GR', cca3: 'GRC' },
  { name: 'Greenland', demonym: 'Greenlandic', cca2: 'GL', cca3: 'GRL' },
  { name: 'Grenada', demonym: 'Grenadian', cca2: 'GD', cca3: 'GRD' },
  { name: 'Guadeloupe', demonym: 'Guadeloupian', cca2: 'GP', cca3: 'GLP' },
  { name: 'Guam', demonym: 'Guamanian', cca2: 'GU', cca3: 'GUM' },
  { name: 'Guatemala', demonym: 'Guatemalan', cca2: 'GT', cca3: 'GTM' },
  { name: 'Guernsey', demonym: 'Channel Islander', cca2: 'GG', cca3: 'GGY' },
  { name: 'Guinea', demonym: 'Guinean', cca2: 'GN', cca3: 'GIN' },
  { name: 'Guinea-Bissau', demonym: 'Guinea-Bissauan', cca2: 'GW', cca3: 'GNB' },
  { name: 'Guyana', demonym: 'Guyanese', cca2: 'GY', cca3: 'GUY' },
  { name: 'Haiti', demonym: 'Haitian', cca2: 'HT', cca3: 'HTI' },
  { name: 'Heard Island and McDonald Islands', demonym: 'Heard and McDonald Islander', cca2: 'HM', cca3: 'HMD' },
  { name: 'Honduras', demonym: 'Honduran', cca2: 'HN', cca3: 'HND' },
  { name: 'Hong Kong', demonym: 'Hong Konger', cca2: 'HK', cca3: 'HKG' },
  { name: 'Hungary', demonym: 'Hungarian', cca2: 'HU', cca3: 'HUN' },
  { name: 'Iceland', demonym: 'Icelander', cca2: 'IS', cca3: 'ISL' },
  { name: 'India', demonym: 'Indian', cca2: 'IN', cca3: 'IND' },
  { name: 'Indonesia', demonym: 'Indonesian', cca2: 'ID', cca3: 'IDN' },
  { name: 'Iran', demonym: 'Iranian', cca2: 'IR', cca3: 'IRN' },
  { name: 'Iraq', demonym: 'Iraqi', cca2: 'IQ', cca3: 'IRQ' },
  { name: 'Isle of Man', demonym: 'Manx', cca2: 'IM', cca3: 'IMN' },
  { name: 'Israel', demonym: 'Israeli', cca2: 'IL', cca3: 'ISR' },
  { name: 'Italy', demonym: 'Italian', cca2: 'IT', cca3: 'ITA' },
  { name: 'Ivory Coast', demonym: 'Ivorian', cca2: 'CI', cca3: 'CIV' },
  { name: 'Jamaica', demonym: 'Jamaican', cca2: 'JM', cca3: 'JAM' },
  { name: 'Japan', demonym: 'Japanese', cca2: 'JP', cca3: 'JPN' },
  { name: 'Jersey', demonym: 'Channel Islander', cca2: 'JE', cca3: 'JEY' },
  { name: 'Jordan', demonym: 'Jordanian', cca2: 'JO', cca3: 'JOR' },
  { name: 'Kazakhstan', demonym: 'Kazakhstani', cca2: 'KZ', cca3: 'KAZ' },
  { name: 'Kenya', demonym: 'Kenyan', cca2: 'KE', cca3: 'KEN' },
  { name: 'Kiribati', demonym: 'I-Kiribati', cca2: 'KI', cca3: 'KIR' },
  { name: 'Kosovo', demonym: 'Kosovar', cca2: 'XK', cca3: 'UNK' },
  { name: 'Kuwait', demonym: 'Kuwaiti', cca2: 'KW', cca3: 'KWT' },
  { name: 'Kyrgyzstan', demonym: 'Kirghiz', cca2: 'KG', cca3: 'KGZ' },
  { name: 'Laos', demonym: 'Laotian', cca2: 'LA', cca3: 'LAO' },
  { name: 'Latvia', demonym: 'Latvian', cca2: 'LV', cca3: 'LVA' },
  { name: 'Lebanon', demonym: 'Lebanese', cca2: 'LB', cca3: 'LBN' },
  { name: 'Lesotho', demonym: 'Mosotho', cca2: 'LS', cca3: 'LSO' },
  { name: 'Liberia', demonym: 'Liberian', cca2: 'LR', cca3: 'LBR' },
  { name: 'Libya', demonym: 'Libyan', cca2: 'LY', cca3: 'LBY' },
  { name: 'Liechtenstein', demonym: 'Liechtensteiner', cca2: 'LI', cca3: 'LIE' },
  { name: 'Lithuania', demonym: 'Lithuanian', cca2: 'LT', cca3: 'LTU' },
  { name: 'Luxembourg', demonym: 'Luxembourger', cca2: 'LU', cca3: 'LUX' },
  { name: 'Macau', demonym: 'Macanese', cca2: 'MO', cca3: 'MAC' },
  { name: 'Macedonia', demonym: 'Macedonian', cca2: 'MK', cca3: 'MKD' },
  { name: 'Madagascar', demonym: 'Malagasy', cca2: 'MG', cca3: 'MDG' },
  { name: 'Malawi', demonym: 'Malawian', cca2: 'MW', cca3: 'MWI' },
  { name: 'Malaysia', demonym: 'Malaysian', cca2: 'MY', cca3: 'MYS' },
  { name: 'Maldives', demonym: 'Maldivan', cca2: 'MV', cca3: 'MDV' },
  { name: 'Mali', demonym: 'Malian', cca2: 'ML', cca3: 'MLI' },
  { name: 'Malta', demonym: 'Maltese', cca2: 'MT', cca3: 'MLT' },
  { name: 'Marshall Islands', demonym: 'Marshallese', cca2: 'MH', cca3: 'MHL' },
  { name: 'Martinique', demonym: 'French', cca2: 'MQ', cca3: 'MTQ' },
  { name: 'Mauritania', demonym: 'Mauritanian', cca2: 'MR', cca3: 'MRT' },
  { name: 'Mauritius', demonym: 'Mauritian', cca2: 'MU', cca3: 'MUS' },
  { name: 'Mayotte', demonym: 'Mahoran', cca2: 'YT', cca3: 'MYT' },
  { name: 'Mexico', demonym: 'Mexican', cca2: 'MX', cca3: 'MEX' },
  { name: 'Micronesia', demonym: 'Micronesian', cca2: 'FM', cca3: 'FSM' },
  { name: 'Moldova', demonym: 'Moldovan', cca2: 'MD', cca3: 'MDA' },
  { name: 'Monaco', demonym: 'Monegasque', cca2: 'MC', cca3: 'MCO' },
  { name: 'Mongolia', demonym: 'Mongolian', cca2: 'MN', cca3: 'MNG' },
  { name: 'Montenegro', demonym: 'Montenegrin', cca2: 'ME', cca3: 'MNE' },
  { name: 'Montserrat', demonym: 'Montserratian', cca2: 'MS', cca3: 'MSR' },
  { name: 'Morocco', demonym: 'Moroccan', cca2: 'MA', cca3: 'MAR' },
  { name: 'Mozambique', demonym: 'Mozambican', cca2: 'MZ', cca3: 'MOZ' },
  { name: 'Myanmar', demonym: 'Bamar', cca2: 'MM', cca3: 'MMR' },
  { name: 'Namibia', demonym: 'Namibian', cca2: 'NA', cca3: 'NAM' },
  { name: 'Nauru', demonym: 'Nauruan', cca2: 'NR', cca3: 'NRU' },
  { name: 'Nepal', demonym: 'Nepalese', cca2: 'NP', cca3: 'NPL' },
  { name: 'Netherlands', demonym: 'Dutch', cca2: 'NL', cca3: 'NLD' },
  { name: 'New Caledonia', demonym: 'New Caledonian', cca2: 'NC', cca3: 'NCL' },
  { name: 'New Zealand', demonym: 'New Zealander', cca2: 'NZ', cca3: 'NZL' },
  { name: 'Nicaragua', demonym: 'Nicaraguan', cca2: 'NI', cca3: 'NIC' },
  { name: 'Niger', demonym: 'Nigerien', cca2: 'NE', cca3: 'NER' },
  { name: 'Nigeria', demonym: 'Nigerian', cca2: 'NG', cca3: 'NGA' },
  { name: 'Niue', demonym: 'Niuean', cca2: 'NU', cca3: 'NIU' },
  { name: 'Norfolk Island', demonym: 'Norfolk Islander', cca2: 'NF', cca3: 'NFK' },
  { name: 'North Korea', demonym: 'North Korean', cca2: 'KP', cca3: 'PRK' },
  { name: 'Northern Mariana Islands', demonym: 'American', cca2: 'MP', cca3: 'MNP' },
  { name: 'Norway', demonym: 'Norwegian', cca2: 'NO', cca3: 'NOR' },
  { name: 'Oman', demonym: 'Omani', cca2: 'OM', cca3: 'OMN' },
  { name: 'Pakistan', demonym: 'Pakistani', cca2: 'PK', cca3: 'PAK' },
  { name: 'Palau', demonym: 'Palauan', cca2: 'PW', cca3: 'PLW' },
  { name: 'Palestine', demonym: 'Palestinian', cca2: 'PS', cca3: 'PSE' },
  { name: 'Panama', demonym: 'Panamanian', cca2: 'PA', cca3: 'PAN' },
  { name: 'Papua New Guinea', demonym: 'Papua New Guinean', cca2: 'PG', cca3: 'PNG' },
  { name: 'Paraguay', demonym: 'Paraguayan', cca2: 'PY', cca3: 'PRY' },
  { name: 'Peru', demonym: 'Peruvian', cca2: 'PE', cca3: 'PER' },
  { name: 'Philippines', demonym: 'Filipino', cca2: 'PH', cca3: 'PHL' },
  { name: 'Pitcairn Islands', demonym: 'Pitcairn Islander', cca2: 'PN', cca3: 'PCN' },
  { name: 'Poland', demonym: 'Polish', cca2: 'PL', cca3: 'POL' },
  { name: 'Portugal', demonym: 'Portuguese', cca2: 'PT', cca3: 'PRT' },
  { name: 'Puerto Rico', demonym: 'Puerto Rican', cca2: 'PR', cca3: 'PRI' },
  { name: 'Qatar', demonym: 'Qatari', cca2: 'QA', cca3: 'QAT' },
  { name: 'Republic of the Congo', demonym: 'Congolese', cca2: 'CG', cca3: 'COG' },
  { name: 'Réunion', demonym: 'French', cca2: 'RE', cca3: 'REU' },
  { name: 'Romania', demonym: 'Romanian', cca2: 'RO', cca3: 'ROU' },
  { name: 'Russia', demonym: 'Russian', cca2: 'RU', cca3: 'RUS' },
  { name: 'Rwanda', demonym: 'Rwandan', cca2: 'RW', cca3: 'RWA' },
  { name: 'Saint Barthélemy', demonym: 'Saint Barthélemy Islander', cca2: 'BL', cca3: 'BLM' },
  { name: 'Saint Helena, Ascension and Tristan da Cunha', demonym: 'Saint Helenian', cca2: 'SH', cca3: 'SHN' },
  { name: 'Saint Kitts and Nevis', demonym: 'Kittitian or Nevisian', cca2: 'KN', cca3: 'KNA' },
  { name: 'Saint Lucia', demonym: 'Saint Lucian', cca2: 'LC', cca3: 'LCA' },
  { name: 'Saint Martin', demonym: 'Saint Martin Islander', cca2: 'MF', cca3: 'MAF' },
  { name: 'Saint Pierre and Miquelon', demonym: 'French', cca2: 'PM', cca3: 'SPM' },
  { name: 'Saint Vincent and the Grenadines', demonym: 'Saint Vincentian', cca2: 'VC', cca3: 'VCT' },
  { name: 'Samoa', demonym: 'Samoan', cca2: 'WS', cca3: 'WSM' },
  { name: 'San Marino', demonym: 'Sammarinese', cca2: 'SM', cca3: 'SMR' },
  { name: 'São Tomé and Príncipe', demonym: 'Sao Tomean', cca2: 'ST', cca3: 'STP' },
  { name: 'Saudi Arabia', demonym: 'Saudi Arabian', cca2: 'SA', cca3: 'SAU' },
  { name: 'Senegal', demonym: 'Senegalese', cca2: 'SN', cca3: 'SEN' },
  { name: 'Serbia', demonym: 'Serbian', cca2: 'RS', cca3: 'SRB' },
  { name: 'Seychelles', demonym: 'Seychellois', cca2: 'SC', cca3: 'SYC' },
  { name: 'Sierra Leone', demonym: 'Sierra Leonean', cca2: 'SL', cca3: 'SLE' },
  { name: 'Singapore', demonym: 'Singaporean', cca2: 'SG', cca3: 'SGP' },
  { name: 'Sint Maarten', demonym: 'St. Maartener', cca2: 'SX', cca3: 'SXM' },
  { name: 'Slovakia', demonym: 'Slovak', cca2: 'SK', cca3: 'SVK' },
  { name: 'Slovenia', demonym: 'Slovene', cca2: 'SI', cca3: 'SVN' },
  { name: 'Solomon Islands', demonym: 'Solomon Islander', cca2: 'SB', cca3: 'SLB' },
  { name: 'Somalia', demonym: 'Somali', cca2: 'SO', cca3: 'SOM' },
  { name: 'South Africa', demonym: 'South African', cca2: 'ZA', cca3: 'ZAF' },
  { name: 'South Georgia', demonym: 'South Georgian South Sandwich Islander', cca2: 'GS', cca3: 'SGS' },
  { name: 'South Korea', demonym: 'South Korean', cca2: 'KR', cca3: 'KOR' },
  { name: 'South Sudan', demonym: 'South Sudanese', cca2: 'SS', cca3: 'SSD' },
  { name: 'Spain', demonym: 'Spanish', cca2: 'ES', cca3: 'ESP' },
  { name: 'Sri Lanka', demonym: 'Sri Lankan', cca2: 'LK', cca3: 'LKA' },
  { name: 'Sudan', demonym: 'Sudanese', cca2: 'SD', cca3: 'SDN' },
  { name: 'Suriname', demonym: 'Surinamer', cca2: 'SR', cca3: 'SUR' },
  { name: 'Svalbard and Jan Mayen', demonym: 'Norwegian', cca2: 'SJ', cca3: 'SJM' },
  { name: 'Sweden', demonym: 'Swedish', cca2: 'SE', cca3: 'SWE' },
  { name: 'Switzerland', demonym: 'Swiss', cca2: 'CH', cca3: 'CHE' },
  { name: 'Syria', demonym: 'Syrian', cca2: 'SY', cca3: 'SYR' },
  { name: 'Taiwan', demonym: 'Taiwanese', cca2: 'TW', cca3: 'TWN' },
  { name: 'Tajikistan', demonym: 'Tadzhik', cca2: 'TJ', cca3: 'TJK' },
  { name: 'Tanzania', demonym: 'Tanzanian', cca2: 'TZ', cca3: 'TZA' },
  { name: 'Thailand', demonym: 'Thai', cca2: 'TH', cca3: 'THA' },
  { name: 'Timor-Leste', demonym: 'East Timorese', cca2: 'TL', cca3: 'TLS' },
  { name: 'Togo', demonym: 'Togolese', cca2: 'TG', cca3: 'TGO' },
  { name: 'Tokelau', demonym: 'Tokelauan', cca2: 'TK', cca3: 'TKL' },
  { name: 'Tonga', demonym: 'Tongan', cca2: 'TO', cca3: 'TON' },
  { name: 'Trinidad and Tobago', demonym: 'Trinidadian', cca2: 'TT', cca3: 'TTO' },
  { name: 'Tunisia', demonym: 'Tunisian', cca2: 'TN', cca3: 'TUN' },
  { name: 'Turkey', demonym: 'Turkish', cca2: 'TR', cca3: 'TUR' },
  { name: 'Turkmenistan', demonym: 'Turkmen', cca2: 'TM', cca3: 'TKM' },
  { name: 'Turks and Caicos Islands', demonym: 'Turks and Caicos Islander', cca2: 'TC', cca3: 'TCA' },
  { name: 'Tuvalu', demonym: 'Tuvaluan', cca2: 'TV', cca3: 'TUV' },
  { name: 'Uganda', demonym: 'Ugandan', cca2: 'UG', cca3: 'UGA' },
  { name: 'Ukraine', demonym: 'Ukrainian', cca2: 'UA', cca3: 'UKR' },
  { name: 'United Arab Emirates', demonym: 'Emirati', cca2: 'AE', cca3: 'ARE' },
  { name: 'United States', demonym: 'American', cca2: 'US', cca3: 'USA' },
  { name: 'United States Minor Outlying Islands', demonym: 'American', cca2: 'UM', cca3: 'UMI' },
  { name: 'United States Virgin Islands', demonym: 'Virgin Islander', cca2: 'VI', cca3: 'VIR' },
  { name: 'Uruguay', demonym: 'Uruguayan', cca2: 'UY', cca3: 'URY' },
  { name: 'Uzbekistan', demonym: 'Uzbekistani', cca2: 'UZ', cca3: 'UZB' },
  { name: 'Vanuatu', demonym: 'Ni-Vanuatu', cca2: 'VU', cca3: 'VUT' },
  { name: 'Vatican City', demonym: 'Vatican', cca2: 'VA', cca3: 'VAT' },
  { name: 'Venezuela', demonym: 'Venezuelan', cca2: 'VE', cca3: 'VEN' },
  { name: 'Vietnam', demonym: 'Vietnamese', cca2: 'VN', cca3: 'VNM' },
  { name: 'Wallis and Futuna', demonym: 'Wallis and Futuna Islander', cca2: 'WF', cca3: 'WLF' },
  { name: 'Western Sahara', demonym: 'Sahrawi', cca2: 'EH', cca3: 'ESH' },
  { name: 'Yemen', demonym: 'Yemeni', cca2: 'YE', cca3: 'YEM' },
  { name: 'Zambia', demonym: 'Zambian', cca2: 'ZM', cca3: 'ZMB' },
  { name: 'Zimbabwe', demonym: 'Zimbabwean', cca2: 'ZW', cca3: 'ZWE' }
]

export const countryNameFromCode = countryCode => {
  for (const country of countries) {
    if (country.cca2 === countryCode || country.cca3 === countryCode) {
      return country.name
    }
  }
  return null
}

const countryNameAliases = {
  'United States of America': 'US'
}

export const countryCodeFromName = countryName => {
  if (!countryName) return null
  const match = countries.find(country => country.name === countryName)
  if (match) return match.cca2
  return countryNameAliases[countryName] || null
}

const NAMIBIA_GROUP_ID = '6d227ea8-3645-4730-9f1e-d1bafd4ed00b'

const tenantCountryOverrides = {
  ireland: 'Ireland',
  southafrica: 'South Africa',
  us: 'United States of America'
}

const countryCodeNameOverrides = {
  US: 'United States of America'
}

export const countryNameFromGlobalConfig = globalConfig => {
  if (!globalConfig) return null
  if (globalConfig.groupId === NAMIBIA_GROUP_ID) return 'Namibia'
  const tenantOverride = tenantCountryOverrides[globalConfig.tenantId]
  if (tenantOverride) return tenantOverride
  const code = globalConfig.countryCode
  if (!code) return null
  return countryCodeNameOverrides[code] || countryNameFromCode(code)
}

export const nationalityOptions = countries
  .filter((v, i, a) => a.findIndex(({ demonym }) => demonym && demonym === v.demonym) === i)
  .map(({ demonym }) => ({ label: demonym, value: demonym }))
